/** Billing API client for subscription management via Stripe. */

import { apiGet, apiPost } from '@/api/client';

export interface SubscriptionInfo {
  plan: 'free' | 'hobby' | 'pro' | 'team';
  status: 'active' | 'canceled' | 'past_due' | 'trialing' | 'none';
  currentPeriodEnd: string | null;
}

interface CheckoutResponse {
  sessionUrl: string;
}

interface PortalResponse {
  portalUrl: string;
}

export async function getSubscription(): Promise<SubscriptionInfo> {
  return apiGet<SubscriptionInfo>('/billing/subscription');
}

export async function createCheckoutSession(priceId: string, quantity = 1): Promise<string> {
  const { sessionUrl } = await apiPost<CheckoutResponse>('/billing/checkout', {
    priceId,
    quantity,
    successUrl: window.location.origin + '/billing/success',
    cancelUrl: window.location.origin + '/billing/cancel',
  });
  window.location.href = sessionUrl;
  return sessionUrl;
}

export async function createPortalSession(): Promise<string> {
  const { portalUrl } = await apiPost<PortalResponse>('/billing/portal', {
    returnUrl: window.location.origin,
  });
  window.location.href = portalUrl;
  return portalUrl;
}
